import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env['VITE_POSTHOG_KEY'] as string | undefined;
const POSTHOG_HOST = import.meta.env['VITE_POSTHOG_HOST'] as string | undefined ?? 'https://app.posthog.com';

let initialized = false;

export function initPostHog(userId?: string) {
  if (!POSTHOG_KEY || initialized) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false,
  });

  if (userId) {
    posthog.identify(userId);
  }

  initialized = true;
}

/**
 * Returns true if the feature flag is enabled.
 * Falls back to true when PostHog is not configured (dev/testing).
 */
export function isFeatureEnabled(flag: string): boolean {
  if (!POSTHOG_KEY || !initialized) return true;
  return posthog.isFeatureEnabled(flag) ?? false;
}

/**
 * Hook to check a PostHog feature flag.
 * Returns true by default when PostHog is not configured.
 */
export function useFeatureFlag(flag: string): boolean {
  return isFeatureEnabled(flag);
}

export { posthog };
